import { useIntl } from '@capsicum/common';

export const useNCWConfirmTransferAddressCard = () => {
	const { $t } = useIntl();

	return {
		intlTexts: {
			from: $t('ncWallet.send.confirmation.from'),
			fromWalletWithUs: $t('ncWallet.send.confirmation.fromWalletWithUs'),
			to: $t('ncWallet.send.confirmation.to'),
			toExternalWallet: $t('ncWallet.send.confirmation.toExternalWallet')
		}
	};
};
